import React, { useState, useEffect } from 'react';

const ModalProfessor = ({ professor, onClose, onSave, departments }) => {
  // Initialize state with the professor's current values
  const [editedProfessor, setEditedProfessor] = useState(professor);

  // Update state when the professor prop changes
  useEffect(() => {
    setEditedProfessor(professor);
  }, [professor]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditedProfessor((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSave = () => {
    onSave(editedProfessor); // Save the updated professor info
  };

  return (
    <div className="fixed inset-0 flex justify-center items-center bg-gray-500 bg-opacity-50">
      <div className="bg-white p-6 rounded-lg w-full sm:w-1/2">
        <h2 className="text-2xl font-semibold mb-4">Edit Professor</h2>

        {/* Professor Info Form */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="mb-4">
            <label className="block font-semibold">First Name</label>
            <input
              type="text"
              name="first_name"
              value={editedProfessor.first_name}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-md"
            />
          </div>

          <div className="mb-4">
            <label className="block font-semibold">Last Name</label>
            <input
              type="text"
              name="last_name"
              value={editedProfessor.last_name}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-md"
            />
          </div>

          <div className="mb-4">
            <label className="block font-semibold">Email</label>
            <input
              type="email"
              name="email"
              value={editedProfessor.email}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-md"
            />
          </div>

          <div className="mb-4">
            <label className="block font-semibold">Department</label>
            <select
              name="department_id"
              value={editedProfessor.department_id}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-md" 
            >
              {departments.map((department) => (
                <option key={department.department_id} value={department.department_id}>
                  {department.department_name}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-4">
            <label className="block font-semibold">Specialization</label>
            <input
              type="text"
              name="specialization"
              value={editedProfessor.specialization}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-md"
            />
          </div>

          <div className="mb-4">
            <label className="block font-semibold">Degree</label>
            <input
              type="text"
              name="degree"
              value={editedProfessor.degree}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-md"
            />
          </div>

          <div className="mb-4">
            <label className="block font-semibold">Office Room</label>
            <input
              type="text"
              name="office_room"
              value={editedProfessor.office_room}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-md"
            />
          </div>

          <div className="mb-4">
            <label className="block font-semibold">Salary</label>
            <input
              type="text"
              name="salary"
              value={editedProfessor.salary}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-md"
            />
          </div>

          <div className="mb-4">
            <label className="block font-semibold">Office Hours</label>
            <input
              type="text"
              name="office_hours"
              value={editedProfessor.office_hours}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-md"
            />
          </div>

          <div className="mb-4">
            <label className="block font-semibold">Mobile Number</label>
            <input
              type="text"
              name="mobile_number"
              value={editedProfessor.mobile_number}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-md"
            />
          </div>

          <div className="mb-4">
            <label className="block font-semibold">Status</label>
            <select
              name="status"
              value={editedProfessor.status}
              onChange={handleChange}
              className="w-full p-2 border border-gray-300 rounded-md"
            >
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select>
          </div>
        </div>

        <div className="flex justify-between mt-4">
          <button
            onClick={onClose}
            className="bg-gray-500 text-white p-2 rounded-md"
          >
            Close
          </button>
          <button
            onClick={handleSave}
            className="bg-blue-500 text-white p-2 rounded-md"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalProfessor;
